"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.match");

//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'OpenApp',
  methods: {
    downloadApp: function downloadApp() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

      if (isAndroid) {
        window.location.href = 'https://www.zunaer.com/android-app-download';
      } else if (isiOS) {
        window.location.href = 'itms-apps://itunes.apple.com/app/id1606844533';
      }
    },
    openApp: function openApp() {
      var _this$$route$query = this.$route.query,
          path = _this$$route$query.path,
          mediaId = _this$$route$query.mediaId,
          isLive = _this$$route$query.isLive;
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端

      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端

      if (isAndroid) {
        if (mediaId && isLive) {
          window.location.href = "zunaersecurities://video?mediaId=".concat(mediaId, "&isLive=").concat(isLive);
        } else {
          window.location.href = "zunaersecurities://over2h5/h52app?".concat(path);
        }
      } else if (isiOS) {
        if (mediaId && isLive) {
          window.location.href = "zunaersecurities://video?mediaId=".concat(mediaId, "&isLive=").concat(isLive);
        } else {
          window.location.href = "zunaersecurities://zixun?".concat(path);
        }
      }
    }
  }
};
exports.default = _default;